import styled from '@emotion/styled';

export const Wrapper = styled.div`
	display: flex;
	justify-content: start;
	padding: 0 11px;
	@media ${({ theme }) => theme.medias.mobile} {
		padding: 0 5px;
	}
`;

export const FilterTab = styled.button<{ isActive: boolean }>`
	background: ${({ isActive }) => (isActive ? '#2E2E3A' : '#e9e9f5')};
	color: ${({ isActive }) => (isActive ? '#FFFFFF' : '#6a6977')};
	font-weight: 600;
	font-size: 12px;
	line-height: 130%;
	margin: 20px 0px 14px 5px;
	padding: 8px 12px;
	border-radius: 20px;
	transition: all 0.2s ease;
	@media ${({ theme }) => theme.medias.mobile} {
		font-size: 11px;
	}
`;

export const SpanMessage = styled.div`
	font-weight: 400;
	font-size: 10px;
	line-height: 150%;
	color: #2e2d37;
	text-align: center;
	margin-bottom: 28px;
	padding: 0px 16px;

	@media ${({ theme }) => theme.medias.mobile} {
		margin-bottom: 16px;
		padding: 0px 12px;
	}
`;
